export default "__VITE_ASSET__CWGrkRMh__"